// extracted by mini-css-extract-plugin
export default {"pricingContainer":"pricing_pricingContainer__NP-XW","banner":"pricing_banner__zWsV6","pricingTitle":"pricing_pricingTitle__tCvuS","pricingDiv":"pricing_pricingDiv__P3ime"};